import { reportErrorInProductionOrThrow } from '~/Utils';

const TEXTS = {
  valueAsWeeks: (value: number) => `${value} ${value === 1 ? 'week' : 'weeks'}`,
  valueAsDays: (value: number) => `${value} ${value === 1 ? 'day' : 'days'}`,
  andSeparator: ' and ',
} as const;

const NON_BREAKING_SPACE = '\u00A0';

const formatDaysAsWeeksAndDays = (days: number, separator = NON_BREAKING_SPACE.repeat(2)) => {
  if (days < 0 || days % 1 !== 0) {
    reportErrorInProductionOrThrow(`Days must be a positive integer, got ${days}`);
    return '';
  }

  if (days === 0) return TEXTS.valueAsWeeks(0);

  const weeks = Math.floor(days / 7);
  const remainingDays = days % 7;
  const weeksAndDays = [
    weeks ? TEXTS.valueAsWeeks(weeks) : null,
    remainingDays ? TEXTS.valueAsDays(remainingDays) : null,
  ]
    .filter(Boolean)
    .join(separator);
  return weeksAndDays;
};

formatDaysAsWeeksAndDays.AND_SEPARATOR = TEXTS.andSeparator;

export default formatDaysAsWeeksAndDays;
